export default __webpack_public_path__ + "static/media/Sagar.d65ff8fa.jpeg";